import React from "react";

const AllVideoTestimonials = () => {
  const range = (min, max) =>
    Array.from({ length: max - min + 1 }, (_, i) => min + i);

  return (
    <div className="w-full pt-5 text-center">
      <div className="">
        <h2 className="md:text-5xl text-2xl mt-5 mb-5 font-bold">
          HEAR WHAT OUR ALUMNI HAVE TO SAY
        </h2>
      </div>
      <div className="w-full px-6 py-10">
        <div className="grid md:grid-cols-3 grid-cols-1 gap-6 justify-items-center">
          {range(0, 12).map((x, i) => (
            <div key={i} className="w-full max-w-md">
              <video
                className={`w-full rounded-lg border-2 border-mgreen ${i >= 11 ? "aspect-square" : ""}`}
                controls
              >
                <source
                  src={`https://iwc-app-bucket.s3.ap-southeast-1.amazonaws.com/videos/Testimonial+Videos/test-video_${x}.mp4`}
                  type="video/mp4"
                />
                Your browser does not support the video tag.
              </video>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default AllVideoTestimonials;
